import { useEffect, useState } from 'react';
import { getAxiosWithToken } from '../../utils/webApi';
import { startLoader, stopLoader } from '../../actions/commonActions';
import DOMPurify from 'dompurify';
import { useDispatch } from 'react-redux';
import { LANGUAGE_CODE_KEY } from '../../utils/constants';

const Gdpr: React.FC<string> = () => {
  const [gdpr, setGdpr] = useState<string>('');
  const dispatch = useDispatch();

  useEffect(() => {
    getTermsAndConditions();
  }, []);

  const getTermsAndConditions = async () => {
    dispatch(startLoader());

    const response = await getAxiosWithToken().get('policies/all');
    const languageBasedPolicies = response.data.data.filter(
      (policies) =>
        policies.languageCode === localStorage.getItem(LANGUAGE_CODE_KEY)
    );

    dispatch(stopLoader());

    if (response.status === 200) {
      setGdpr(DOMPurify.sanitize(languageBasedPolicies[0].gdpr));
    }
  };
  return (
    <div
      id="gdpr"
      style={{ marginBottom: '80px' }}
      dangerouslySetInnerHTML={{ __html: gdpr }}
    />
  );
};

export default Gdpr;
